import request from '@/router/axios'
import env from '@/config/env'

/**
 * 搜索枚举
 * @returns
 */
export const getEnums = () => {
  return request({
    url: `${env.officeUrl}/employee/enum`,
    method: 'GET',
  })
}

/**
 * 保存员工
 * @returns
 */
export const saveEmployee = (params) => {
  return request({
    url: `${env.officeUrl}/employee/save`,
    method: 'POST',
    data: params,
  })
}

/**
 * 获取人员分页
 * @returns
 */
export const getEmployeePage = (params) => {
  return request({
    url: `${env.officeUrl}/employee/page`,
    method: 'POST',
    data: params,
  })
}

/**
 * 获取员工详情
 * @returns
 */
export const getEmployee = (params) => {
  return request({
    url: `${env.officeUrl}/employee/detail`,
    method: 'GET',
    params,
  })
}

/**
 * 获取员工详情
 * @returns
 */
export const getEmployeeForProfile = (params) => {
  return request({
    url: `${env.officeUrl}/employee/profile`,
    method: 'GET',
    params,
  })
}

/**
 * 保存员工简单信息
 * @returns
 */
export const saveEmployeeSimpleInfo = (params) => {
  return request({
    url: `${env.officeUrl}/employee/simple/save`,
    method: 'POST',
    data: params,
  })
}

/**
 * 搜索员工
 * @returns
 */
export const searchEmployee = (params) => {
  return request({
    url: `${env.officeUrl}/employee/search`,
    method: 'GET',
    params,
  })
}

/**
 * 员工概述
 * @returns
 */
export const getEmployeeOverview = (params) => {
  return request({
    url: `${env.officeUrl}/employee/overview`,
    method: 'GET',
    params,
  })
}

/**
 * 保存员工记录
 * @returns
 */
export const saveEmployeeRecord = (params) => {
  return request({
    url: `${env.officeUrl}/employee/record/save`,
    method: 'POST',
    data: params,
  })
}

/**
 * 二次入职
 * @returns
 */
export const employeeRetry = (params) => {
  return request({
    url: `${env.officeUrl}/employee/retry`,
    method: 'PUT',
    params,
  })
}
